export const siteConfig = {
  name: '4688.tv',
  tagline: '精彩内容一触即达',
  description:
    '4688.tv 是您值得信赖的在线视频平台，汇聚海量精彩内容，高清流畅播放，随时随地畅享娱乐体验。',
  url: 'https://4688.tv',
  ogImage: '',
  foundingYear: 2018,
  stats: {
    totalContent: '50,000+',
    activeUsers: '8,000万',
    dailyViews: '2.5亿',
    coverage: '190+',
  },
  features: [
    {
      icon: 'ri-4k-line',
      title: '超高清画质',
      description: '支持4K/8K超高清播放，HDR与杜比视界技术，每一个细节都纤毫毕现',
    },
    {
      icon: 'ri-speed-line',
      title: '流畅不卡顿',
      description: '全球CDN加速节点覆盖，智能码率自适应技术，随时随地畅享流畅播放',
    },
    {
      icon: 'ri-translate',
      title: '多语言字幕',
      description: '支持中英日韩等十余种语言字幕，AI实时翻译，跨语言观影无障碍',
    },
    {
      icon: 'ri-device-line',
      title: '全终端支持',
      description: '网页、手机App、平板、智能电视全覆盖，一个账号多设备无缝切换',
    },
    {
      icon: 'ri-download-line',
      title: '离线下载',
      description: '支持视频离线缓存，地铁、飞机上也能畅快观影，不受网络限制',
    },
    {
      icon: 'ri-shield-check-line',
      title: '正版保障',
      description: '所有内容均来自正版授权，严格版权保护，为创作者和观众负责',
    },
  ],
  milestones: [
    { year: '2018', event: '4688.tv 正式上线，开启在线视频平台之旅' },
    { year: '2019', event: '用户突破1000万，获得A轮融资' },
    { year: '2020', event: '推出4K专区，内容库突破10,000部' },
    { year: '2021', event: '上线AI智能推荐系统，用户满意度大幅提升' },
    { year: '2022', event: '日活跃用户突破5000万，行业排名前三' },
    { year: '2023', event: '获得年度最佳视频平台奖，内容库突破30,000部' },
    { year: '2024', event: '国际化战略启动，覆盖海外190+国家和地区' },
    { year: '2025', event: '推出8K超高清专区，AI字幕翻译覆盖15种语言' },
    { year: '2026', event: '会员数突破1亿，持续引领在线视频行业创新' },
  ],
  contact: {
    email: 'contact@4688.tv',
    phone: '400-888-4688',
    address: '北京市朝阳区望京科技园4688.tv大厦',
    wechat: '4688tv官方',
    weibo: '@4688tv官方微博',
  },
  faqs: [
    {
      question: '4688.tv 是否需要付费？',
      answer:
        '4688.tv 提供免费和付费两种观看模式。部分内容支持免费观看（含广告），会员用户可享受无广告、超高清画质、离线下载、独家内容等专属权益。我们提供月度、季度和年度多种会员方案，新用户注册即享7天免费会员体验。',
    },
    {
      question: '如何注册 4688.tv 账号？',
      answer:
        '您可以通过手机号、邮箱或第三方账号（微信、QQ、Apple ID）快速注册 4688.tv 账号。访问官网或下载App后，点击"注册"按钮，按照提示填写信息并完成验证即可。注册过程简单快捷，仅需1-2分钟。',
    },
    {
      question: '4688.tv 支持哪些设备观看？',
      answer:
        '4688.tv 支持全终端观看，包括：网页端（Windows/Mac浏览器）、移动端（iOS/Android App）、平板端（iPad/Android Pad）、智能电视（Apple TV / Android TV / 各大品牌智能电视）、游戏主机（PS5 / Xbox Series）。一个会员账号可在最多5台设备上同时使用。',
    },
    {
      question: '视频播放卡顿怎么办？',
      answer:
        '如果您遇到播放卡顿问题，可以尝试以下方法：1）在播放器右下角手动切换至更低清晰度（如从4K切换至1080P）；2）检查您的网络连接是否稳定，建议至少5Mbps带宽；3）清除浏览器缓存或重启App；4）如问题持续，请联系客服获取技术支持。',
    },
    {
      question: '会员自动续费如何取消？',
      answer:
        '您可以在"我的账户 - 会员中心 - 订阅管理"中随时取消自动续费。取消后当前会员周期不受影响，到期后将不再自动续费。我们不会在您取消后续费后仍收取费用。如需帮助，请随时联系客服。',
    },
    {
      question: '4688.tv 的内容是否为正版？',
      answer:
        '是的，4688.tv 平台所有内容均来自正规版权渠道。我们与国内外数百家影视公司、电视台和内容制作方建立了长期合作关系，确保平台上的每一部作品都拥有合法授权。我们坚决支持正版，反对盗版，为创作者和行业生态负责。',
    },
  ],
};